module.exports = __webpack_public_path__ + "img/full_wallet.png";